import React from 'react'
import styled from 'styled-components'

export const ActualPath = styled.path`
  stroke: steelblue;
  stroke-width: 3px;
  stroke-linejoin: round;
  fill: none;
`
const predColor = '#9467bd'
export const ActualDot = styled.circle`
  fill: steelblue;
`
export const PredictedPath = styled.path`
  stroke: ${predColor};
  stroke-width: 3px;

  stroke-linejoin: round;
  fill: none;
  stroke-opacity: ${({ isHistorical }) => (isHistorical ? '.5' : '1')};
`
export const PredictedDot = styled.circle`
  fill: white;
  stroke: ${predColor};
  stroke-width: 3px;
  stroke-opacity: ${({ isHistorical }) => (isHistorical ? '.5' : '1')};
`
